/* import __COLOCATED_TEMPLATE__ from './sort-select.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import { action } from '@ember/object';
import type OptimizeSuggestionsService from 'embercom/services/optimize-suggestions-service';
import { OptimizeSuggestionSortBy } from 'embercom/components/reporting/automation/ai-insights/optimize-suggestions/lib/constants';

type SortItem = {
  buttonText: string;
  dropdownText: string;
  value: OptimizeSuggestionSortBy;
};

type SortOption = {
  items: SortItem[];
};

interface Signature {
  Args: {
    optimizeSuggestionsService: OptimizeSuggestionsService;
    isDisabled?: boolean;
  };
}
export default class SortSelect extends Component<Signature> {
  @service declare intl: IntlService;
  @service intercomEventService: $TSFixMe;

  get sortOptions(): SortOption[] {
    return [
      {
        items: [
          {
            buttonText: this.intl.t(
              'components.reporting.automation.optimize-suggestions.sort.impact',
            ),
            dropdownText: this.intl.t(
              'components.reporting.automation.optimize-suggestions.sort.impact-high-to-low',
            ),
            value: OptimizeSuggestionSortBy.Impact,
          },
          {
            buttonText: this.intl.t(
              'components.reporting.automation.optimize-suggestions.sort.date',
            ),
            dropdownText: this.intl.t(
              'components.reporting.automation.optimize-suggestions.sort.date-newest-to-oldest',
            ),
            value: OptimizeSuggestionSortBy.Date,
          },
        ],
      },
    ];
  }

  get selectedSortItem(): SortItem {
    let currentSort = this.args.optimizeSuggestionsService.sortBy;
    return (
      this.sortOptions[0].items.find((option) => option.value === currentSort) ||
      this.sortOptions[0].items[0]
    );
  }

  @action
  onSelectItem(value: OptimizeSuggestionSortBy) {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'clicked',
      object: 'suggestion_sort_select',
      sort_by: value,
    });
    this.args.optimizeSuggestionsService.setSortBy(value);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::OptimizeSuggestions::Suggestions::SortSelect': typeof SortSelect;
    'reporting/automation/ai-insights/optimize-suggestions/suggestions/sort-select': typeof SortSelect;
  }
}
